<template>
  <page-layout>
    <div class="dashboard-wrapper">
      <a-row :gutter="16" justify="space-between" align="top">
        <!-- 机构信息 -->
        <a-col v-if="college" :xs="24" :lg="24" :xl="12" :xxl="6">
          <a-card title="机构信息" class="card">
            <div class="college-wrapper">
              <div style="text-align: center">
                <a-avatar :size="120" :src="college.badge"></a-avatar>
              </div>
              <div class="title">{{ college.name }}</div>
              <div class="item">系统管理员：{{ college.contactPerson.name }}</div>
              <div class="item">所在地：{{ college.location.join(' / ') }}</div>
              <div class="item">街道地址：{{ college.streetAddress }}</div>
              <div class="item">联系电话：{{ college.contactPerson.telephone }}</div>
              <div class="item">联系邮箱：{{ college.contactPerson.email }}</div>
              <router-link :to="{name: 'CollegeBaseSettings'}" class="edit">修改基本信息</router-link>
            </div>
          </a-card>
        </a-col>
        <!-- 最新动态 -->
        <a-col :xs="24" :lg="24" :xl="12" :xxl="6">
          <a-card title="最新动态" class="card">
            <div class="moments-wrapper">
              <a-timeline>
                <template v-for="(item, index) in projectMoments">
                  <a-timeline-item :key="index">
                    <a-tag color="#FDE9EA">
                      <span style="color: #F4282D;">{{ item.createdAt | moment }}</span>
                    </a-tag>
                    <div>
                      <router-link
                        :to="{ name: 'ProjectDetail', params: { projectId: item.project.id } }"
                      >
                        <div class="project-link">{{ item.project.name }}</div>
                      </router-link>
                      {{ item.content.split(item.project.name).join(' ') }}
                    </div>
                  </a-timeline-item>
                </template>
              </a-timeline>
              <div style="margin-top: 20px">
                <a-button
                  v-if="momentPagination.count > projectMoments.length"
                  @click="showMoreMoments"
                >加载更多 ▼</a-button>
                <a-button disabled v-else>没有更多动态了</a-button>
              </div>
            </div>
          </a-card>
        </a-col>
        <!-- 待办事项 -->
        <a-col :xs="24" :lg="24" :xl="24" :xxl="12">
          <a-card title="待处理事项">
            <template slot="extra">
              <a-popconfirm title="确定将本页消息全部置为已读？" @confirm="markRead('all')">
                <a-button type="primary" icon="issues-close" size="small">标记本页已读</a-button>
              </a-popconfirm>
            </template>
            <div class="notifications-wrapper">
              <div style="height: 400px">
                <a-list
                  itemLayout="horizontal"
                  :dataSource="notifications"
                  :locale="{ emptyText: '暂无新消息' }"
                >
                  <a-list-item slot="renderItem" slot-scope="item, index">
                    <div
                      :class="['notification', !item.isRead && 'active']"
                      @click="markRead('single', index)"
                    >
                      <!-- <div class="content">
                        <span v-html="item.content"></span>
                      </div>
                      <div class="date">{{ item.createdAt | moment }}</div>-->
                      <a-row :gutter="8" type="flex" justify="space-between" align="top">
                        <!-- 通知内容 -->
                        <a-col :span="16">
                          <div class="content">
                            <span v-html="item.content"></span>
                          </div>
                        </a-col>
                        <!-- 查看 -->
                        <a-col :span="4">
                          <template v-if="item.scene && item.relevantId">
                            <div class="action">
                              <a-button
                                v-if="!(isProjectManager && item.scene === 'applying_for_manager')"
                                type="dashed"
                                size="small"
                                style="color: #1890ff;"
                                @click="viewNotification(item)"
                              >查看</a-button>
                            </div>
                          </template>
                        </a-col>
                        <!-- 时间 -->
                        <a-col :span="4">
                          <div class="date">{{ item.createdAt | moment }}</div>
                        </a-col>
                      </a-row>
                    </div>
                  </a-list-item>
                </a-list>
              </div>
              <div style="margin: 15px 0;text-align: right">
                <a-pagination
                  :defaultCurrent="notificationPagination.pageNo"
                  :pageSize.sync="notificationPagination.pageSize"
                  :total="notificationPagination.count"
                  @change="pageChange"
                />
              </div>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </page-layout>
</template>

<script>
import { mapState } from 'vuex'
import { mixin } from '@/utils/mixin'
import { Colleges, Notifications, ProjectMoments } from '@/resources'
import { createViewRoute } from '@/views/account/settings/notificationUtil'
import PageLayout from '@/components/page/PageLayout'

export default {
  mixins: [mixin],
  components: { PageLayout },
  data () {
    return {
      college: null,
      projectMoments: [],
      notifications: [],
      momentPagination: {
        pageNo: 1,
        pageSize: 10,
        count: 0
      },
      notificationPagination: {
        pageNo: 1,
        pageSize: 8,
        count: 0
      }
    }
  },
  created () {
    const vm = this
    vm.fetchCollegeInfo()
    vm.fetchProjectMoments()
    // vm.fetchNotifications()
  },
  computed: {
    ...mapState({
      basicInfo: state => state.user.basicInfo
    })
  },
  methods: {
    async fetchCollegeInfo () {
      const data = await Colleges.find()
      this.college = data.college
    },
    async fetchProjectMoments () {
      const { projectMoments, count } = await ProjectMoments.listOfCollege(this.momentPagination)
      this.projectMoments.push(...projectMoments)
      this.momentPagination.count = count
    },
    showMoreMoments () {
      const vm = this
      vm.momentPagination.pageNo++
      vm.fetchProjectMoments()
    },
    markRead (range, index) {
      if (range === 'all') {
        new Promise(resolve => {
          Promise.all(this.notifications.map(({ id }) => Notifications.read(id))).then(() => {
            resolve()
          })
        }).then(() => {
          this.notificationPagination = {
            pageNo: 1,
            pageSize: 8,
            count: 0
          }
          this.fetchNotifications()
          this.resetUnreadNotificationsCount()
        })
      } else {
        Notifications.read(this.notifications[index].id).then(() => {
          this.resetUnreadNotificationsCount()
        })
        this.notifications.splice(index, 1)
      }
    },
    pageChange (current) {
      this.notificationPagination.pageNo = current
      this.fetchNotifications()
    },
    async fetchNotifications () {
      const { notifications, count } = await Notifications.list(Object.assign({ isRead: 'no' }, this.notificationPagination))
      this.notifications = notifications
      this.notificationPagination.count = count
    },
    resetUnreadNotificationsCount () {
      Notifications
        .getUnreadCount()
        .then(({ count }) => {
          this.$store.dispatch('SetCounts', { notification_count: count })
        })
        .catch(error => {
          console.error('获取未读通知数出错', error)
        })
    },
    viewNotification (notification) {
      const route = createViewRoute(notification)
      this.$router.push(route)
    }
  }
}
</script>

<style scoped lang="less">
.dashboard-wrapper {
  .card {
    margin-bottom: 16px;
  }
  .college-wrapper {
    height: 480px;
    .title {
      font-size: 20px;
      font-weight: 800;
      color: rgba(51, 51, 51, 1);
      margin: 30px 0;
      text-align: center;
    }
    .item {
      padding: 0 15%;
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: 500;
      color: #666;
      line-height: 20px;
    }
    .edit {
      float: right;
      margin-top: 20px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(244, 40, 45, 1);
      line-height: 17px;
    }
  }
  .moments-wrapper {
    overflow: auto;
    height: 480px;
    padding-top: 10px;
    .project-link {
      padding: 10px 0;
      font-size: 16px;
      font-weight: 700;
      color: #666;
      &:hover {
        color: #c8161e;
      }
    }
  }
  .notifications-wrapper {
    height: 480px;
    .notification {
      width: 100%;
      padding-left: 30px;
      position: relative;
      &.active {
        cursor: pointer;
        &:before {
          display: block;
        }
      }
      &:before {
        display: none;
        content: '';
        position: absolute;
        left: 10px;
        top: 10px;
        width: 6px;
        border-radius: 50%;
        height: 6px;
        background-color: #e9423d;
      }
      .content {
        font-size: 14px;
        color: rgba(131, 146, 167, 1);
        max-height: 48px;
        display: inline;
      }
      .action {
        text-align: right;
      }
      .date {
        font-size: 12px;
        color: #999;
        text-align: right;
        max-height: 48px;
      }
    }
  }
}
</style>
